<template>
<!-- Public Affairs :: Videos and Charticles  --> 
<section class="videos-and-charticles">
    <h3 class="section-heading">Multimedia</h3>
    <div class="videos-charticales-items clearfix">
        <template v-for="(post, vindex) in section.posts"  >
            <div class="card" v-bind:key="vindex" v-if="(vindex+1) <= section.item_limit"  >
                <div class="asset" :id="post.id" >
                        <template v-if="check_if_embed_exists(post) == true">
                            <img @click="display_video_embed(post)" :src="replace_image_size(post.img_url)" 
                                :alt="post.excerpt" :title="post.title" class="img-embed" >
                            <div @click="display_video_embed(post)" class="video-icon"></div>
                            <div class="embed-wrapper" v-if="post.embed_expanded == true">
                                <div @click="close_embed_modal(post)" class="close-modal"><i class="far fa-times-circle"></i></div>
                                <div class="embed" v-html="post.media_embed"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div>
                                <a :href="post.url" :target="hrefTarget">
                                    <img :src="replace_image_size(post.img_url)" :alt="post.excerpt" :title="post.title" />
                                </a>
                            </div>
                        </template>
                </div>
                <div class="asset-title"><a :href="post.url" :target="hrefTarget">{{post.title}}</a></div>
                <div class="publication">{{post.byline}}</div>
            </div>
        </template>
    </div>
    <div v-if="section.item_limit < section.posts.length" 
        class="load-more" @click="displayMorePostsForSection(section)">Load More</div>
</section><!-- End .v-n-c section --> 
</template>

<script>

import SectionsMixin from './SectionsMixin.js';

export default {
    name: 'multimedia',
    mixins: [
        SectionsMixin,
    ],
    methods: {

        display_video_embed: function (post) { // will display modal overlay iframe

            if (typeof post.embed_expanded == 'undefined') {
                this.$set(post, 'embed_expanded', false);
            }

            post.embed_expanded = !post.embed_expanded;

            this.$emit('toggle-overlay', true);
            // this.isActive = true

        },

        check_if_embed_exists: function (post) {

            if (post.media_embed !== undefined && post.media_embed !== null) {
                return true;
            }
            
            return false;
        },

        close_embed_modal: function (post) {
            this.$emit('toggle-overlay', false);
            // this.isActive = false
            post.embed_expanded = false
        },
    },
}
</script>